import {
  ACTION_TYPE,
  COUNTDOWN_TYPE,
} from "@circle-react/types/PaywallCustomization";

export const isRemainingTimeType = (input?: string | null) =>
  input === COUNTDOWN_TYPE.REMAINING_TIME;
export const isFinishAtType = (input?: string | null) =>
  input === COUNTDOWN_TYPE.FINISH_AT;

export const isRedirectToType = (input?: string | null) =>
  input === ACTION_TYPE.REDIRECT_TO;
export const isDoNothingType = (input?: string | null) =>
  input === ACTION_TYPE.DO_NOTHING;

export const REMAINING_TIME_DEFAULT_VALUE = 10;

export const skipCountdownRedirectsName = "skip_redirect";
